import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import {ReactElement} from "react";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "shared/components/AppComponents";
import {CloseDialogIcon} from "assets/styles/icons";

const DeleteConfirmation = (props: any): ReactElement => {
  const {showConfirm, onCloseForm, deleteDirector, isDeleting} = props;

  return (
    <>
      <Dialog
        open={showConfirm}
        fullWidth
        maxWidth="sm"
        // className="account-dailog-wrapper"
      >
        <DialogTitle>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h2">Confirmation</Typography>
            <IconButton onClick={onCloseForm}>
              <CloseDialogIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" className="f15">
            Are you sure you want to delete this user?
          </Typography>
        </DialogContent>

        <DialogActions className="p-6">
          <AppSecondaryButton
            title="Cancel"
            className="btn-small"
            onClick={onCloseForm}
            disabled={isDeleting}
          />
          <AppPrimaryButton
            title="Delete"
            className="btn-small"
            isLoading={isDeleting}
            disabled={isDeleting}
            loadingText="DELETING"
            onClick={deleteDirector}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteConfirmation;
